<template>
  <el-dialog title="费用报销单" :visible.sync="dialogFormVisible" custom-class="fix-dialog" center :close-on-click-modal="false"
    :append-to-body="true" :modal="true">
    <el-form :model="form" ref="formPayInfo" :rules="rules">
      <!-- 费用明细组件 -->
      <PaydetailEdit ref="PaydetailEdit" @bindFeeGrid="bindFeeGrid" :payGuid="form.unitguid" :tableDataFee="tableDataFee"
        :parentCategoryCode="parentCategoryCode" :parentCategoryName="parentCategoryName" :formallowedit="form.formallowedit"></PaydetailEdit>
      <!-- 选择费用类别组件 -->
      <SelectFeeType ref="SelectFeeType" filltemplate="报销" :parentcategorycode="parentCategoryCode" @afterSelFeeType="afterSelFeeType"></SelectFeeType>
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <span>基本信息</span>
          </template>
          <el-row>
            <el-col :span="8">
              <el-form-item label="申请人" :label-width="formLabelWidth"> {{ form.uname }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="部门" :label-width="formLabelWidth"> {{ form.dname }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="填单日期" :label-width="formLabelWidth"> {{ form.adddate }}
              </el-form-item>
            </el-col>
          </el-row>
          <!--<el-row v-show="false">-->
            <!--<el-col :span="8">-->
              <!--<el-form-item label="收款人" :label-width="formLabelWidth">-->
                <!--<CommTreeViewDialog ref="applyTree" @check="afterSelectApply" :options="applyTreeOption"></CommTreeViewDialog>-->
                <!--<el-input type="text" placeholder="选择收款人" readonly style="width: 150px;" v-model="form.applyby"-->
                  <!--@click.native="openSelectApply()"></el-input>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
            <!--<el-col :span="8">-->
              <!--<el-form-item label="核算部门" :label-width="formLabelWidth">-->
                <!--<CommTreeViewDialog ref="deptTree" @check="afterSelectDept" :options="deptTreeOption"></CommTreeViewDialog>-->
                <!--<el-input type="text" placeholder="选择部门" readonly style="width: 150px;" v-model="form.applybydname"-->
                  <!--@click.native="openSelectDept()"></el-input>-->
              <!--</el-form-item>-->
            <!--</el-col>-->
          <!--</el-row>-->
          <el-row>
            <el-col :span="24">
              <el-form-item label="付款事由" :label-width="formLabelWidth" prop="remark">
                <el-input type="textarea" placeholder=""  v-model="form.remark" :autosize="{ minRows: 2, maxRows: 20}"  :required="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="关联客户" :label-width="formLabelWidth" prop="hetongserial">
                <AutoCustomer ref="AutoCustomer1" @clear="clearCustomerName" :size="'small'"  @handleSelect="afterSelExternalDept" :unitgroup="''" :content="form.hetongname" :disabled="!(form.formAllowEdit||!form.casestatus)"></AutoCustomer>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div style="display:inline-block;width:100%;">
              <span style="float:left">费用明细</span>
              <div style="float:right;padding-right: 20px">
                <el-button v-if="(form.casestatus=='0'&&form.formAllowEdit)||form.casestatus==''" href="javascript:void(0);" size="small"
                  @click.stop="addFeeDetail()" type="primary" icon="el-icon-plus" circle></el-button>
              </div>
            </div>
          </template>
          <el-table :data="tableDataFee" size="mini" stripe border show-summary :summary-method="getFeeSummaries" style="width: 100%;">
            <el-table-column align="center" header-align="center" label="序" width="60">
            <template slot-scope="scope">
              {{1+scope.$index}}
            </template>
            </el-table-column>
            <el-table-column prop="feedate" label="日期" align="center" header-align="center" width="120">
              <template slot-scope="scope">
                {{ scope.row.feedate?scope.row.feedate.substr(0, 10):"" }}
              </template>
            </el-table-column>
            <el-table-column prop="categoryname" label="类别" align="center" header-align="center" width="120"></el-table-column>
            <el-table-column prop="feemoney" align="right" header-align="right" label="金额" width="120">
              <template slot-scope="scope">
                {{scope.row.feemoney|numeric(2)}}
              </template>
            </el-table-column>
            <el-table-column prop="taxmoney" align="right" header-align="right" label="税额" width="80">
              <template slot-scope="scope">
                {{scope.row.taxmoney|numeric(2)}}
              </template>
            </el-table-column>
            <el-table-column prop="remark" align="left" header-align="center" label="备注">
              <template slot-scope="scope">
                {{scope.row.remark}}
                <el-tag type="danger" v-if="scope.row.musttax==1">未使用增值税专票</el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" header-align="center" label="附件" width="60">
              <template slot-scope="scope">
                <icon v-if="scope.row.hasattach>0" class="el-icon-paperclip"></icon>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="200">
              <template slot-scope="scope">
                <el-button size="mini" @click="editFeeDetail(scope.$index, scope.row)">{{form.formallowedit?"修改":"查看"}}
                </el-button>
                <el-button v-show="(form.casestatus=='0'&&form.formAllowEdit)||form.casestatus==''" size="mini" type="danger" @click="delFeeDetail(scope.$index, scope.row)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
        <el-collapse-item name="5" v-if="isPayStep">
          <template slot="title">
            <span>付款</span>
          </template>
          <PayMoney ref="paymoney" :payguid="form.unitguid" :paymoney="form.paymoney" :hexiaomoney="form.offsetcash" :tenantid="form.tenantid"
            :paydate="form.paydate" formname="报销" :formallowedit="isPayStep&&form.casestatus!='9'" :isFinancial="isFinancial"></PayMoney>
        </el-collapse-item>
        <el-collapse-item name="6">
          <template slot="title">
            <span>审批流程</span>
          </template>
          <el-row>
            <el-col :span="24">
              <WorkflowView ref="wfView"></WorkflowView>
            </el-col>
          </el-row>
        </el-collapse-item>
      </el-collapse>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="info" @click="print" v-if="parseFloat(this.form.casestatus)>=6">打印</el-button>
      <WorkflowButton ref="wfHandle" @saveWorkFlow="saveData" @deleteWorkFlow="deleteData" @closeDialog="dialogFormVisible = false"></WorkflowButton>
      <PayPrint ref="PayPrint"></PayPrint>
    </div>
    <span slot="title" style="font-size: larger;">
      <div>{{ form.feename }}报销单 <span class="erpserial">{{ form.erpserial }}</span></div>

    </span>
  </el-dialog>
</template>
<style scoped>
  .erpserial {
    font-size: 10px;
  }
</style>
<script>
  import {
    saveDataBaoXiao,
    getDetail,
    deleteData
  } from "@/api/pay/paymain";
  import {
    getUnSubmitPayDetailList,
    deleteFeeDetail,
    getPayDetailByPayGuid
  } from "@/api/pay/paydetail";
  import PaydetailEdit from "./PaydetailEdit_BaoXiao";
  import SelectFeeType from "./SelectFeeType";
  import PayMoney from "./PayMoney";
  import {convertToBigMoney,ConvertMoney} from "@/plugin/ordercommon";
  import PayPrint from "./PayPrint";
  import CommTreeViewDialog from "@/components/common/CommTreeViewDialog"; //引用部门人员选择对话框
  export default {
    name: "ReimburseEdit",
    data() {
      return {
        isFinancial: false, //是否财务人员
        dialogFormVisible: false,
        activeNames: ["1", "2", "5", "6"],
        applyuserauditlevel: "999999", //申请人岗位级别
        userModel:{},
        workflowParam: {}, //工作流参数，这个地方用来存储下，方便在线支付确认后重新调用保存方法
        form: {
          formallowedit: true,
          //定义表单参数（不要在这里赋默认值 统一在initForm中初始化）
          unitguid: "",
          summary: "",
          paymoney: "", //
          casestatus: "", //上级部门
          casestepname: "",
          flag: "",
          remark: "",
          applyby: "",
          applybyguid: "",
          applybydname: "",
          applybydserial: "",
          hetongname: "",
          hetongserial: "",
          currency: "",
          customername: "",
          customerserial: "",
          bank: "",
          tenantid:"",
          bankaccount: "",
          bankname: "", //银行名称
          formtype: "ZF",
          formname: "付款单", //报销单BX;付款单ZF;备用金申请单
          feetype: "", //费用大类编码
          feename: "",
          exchangerate: "1", //汇率
          paydate: "",
          payuname: "",
          payuguid: "",
          offsetcash: 0, //抵消备用金
          offsetcashjson: [], //抵消备用金明细
          localcurrency: "", //折算本币金额
          bigfeemoney: "", //大写金额
          erpserial: "", //单据号
          shouxufee: "", //手续费
          paymethoddata: [], //付款方式
          payyusuandata: [], //使用预算信息
          financialmenucode: "", //蜘蛛财务费用菜单编码
        },
        parentCategoryName: "", //给费用明细页面传值用
        parentCategoryCode: "", //给费用明细页面传值用
        feecode: "", //选择的费用类别编码
        feename: "", //选择的费用类别名称
        MustFaPiao: false,
        needfapiao: true, //选择的费用是否需要发票，默认需要
        tableDataFee: [], //费用列表
        isPayStep: false, //是否付款步骤
        formLabelWidth: "120px",
        payinfo: {},
        todolist: [],
        rules: {
          remark: [{
            required: true,
            message: "请填写付款事由",
            trigger: "blur"
          }]
        }
      };
    },

    computed: {
      //获取大写金额
      bigfeemoney: function() {
        return convertToBigMoney(this.form.paymoney);
      },
      //人员选择树参数
      applyTreeOption: function() {
        return {
          title: "选择收款人",
          rowindex: 1,
          texts: this.form.applyby,
          ids: this.form.applybyguid,
          canSelectGroupTypeNode: false,
          useRight: false,
          menuguid: "" //菜单guid
        }

      },
      //部门选择树参数
      deptTreeOption: function() {
        return {
          title: "选择部门",
          rowindex: 1,
          texts: this.form.applybydname,
          ids: this.form.applybydserial,
          canSelectGroupTypeNode: true,
          onlyShowGroupType: true,
          useRight: false,
          fdpath: this.userModel.fdpath,
          menuguid: "" //菜单guid
        }
      },
    },

    methods: {
      //客服填写订单选择门店之后模拟登录
      afterSelExternalDept(customerserial, customername, row) {
        this.form.hetongserial=customerserial;
        this.form.hetongname=customername;
      },
      clearCustomerName() {
        this.form.hetongserial='';
        this.form.hetongname='';
      },
      addPage(categorycode, categoryname) {
        //新增
        this.initForm();
        this.parentCategoryName = categoryname; //给费用明细页面传值用
        this.parentCategoryCode = categorycode; //给费用明细页面传值用
        //this.form.formname = '报销单'; //报销单BX;付款单ZF;备用金申请单,暂去除，由工作流统一生成
        this.form.formtype = "BX"; //报销单BX;付款单ZF;备用金申请单
        this.isPayStep = false; //是否付款步骤
        this.form.feetype = categorycode;
        this.form.feename = categoryname;
        this.form.currency = "RMB";
        this.form.exchangerate = "1"; //税率
        this.tableDataFee = [];
        var userinfo = this.userModel;
        this.form.uguid = userinfo.uguid;
        this.form.uname = userinfo.uname;
        this.form.dserial = userinfo.dserial;
        this.form.dname = userinfo.dname;
        this.form.applyby = userinfo.uname;
        this.form.applybyguid = userinfo.uguid;
        this.form.applybydserial = userinfo.dserial;
        this.form.applybydname = userinfo.dname;

        var today = new Date();
        this.form.adddate =
          today.getFullYear() +
          "-" +
          (today.getMonth() + 1) +
          "-" +
          today.getDate();

        //根据uguid，和分类编码  绑定费用明细
        this.bindFeeGrid();
        this.$refs.wfHandle.InitAddButton(); //初始化 第一次提交时的工作流按钮
      },
      editPage(unitguid) {
        //修改
        this.initForm();
        this.form.paymoney = 0;
        this.form.flag = false; //修改状态下 flag=false
        getDetail({
          unitguid: unitguid
        }).then(response => {
          this.form = response.data.obj;

          //payguid绑定费用明细
          this.bindFeeGrid(unitguid);
          this.parentCategoryCode = this.form.feetype; //给费用明细页面传值用
          this.parentCategoryName = this.form.feename; //给费用明细页面传值用
          var wfData=JSON.parse(this.form.workflow);
          var formallowedit = this.$refs.wfHandle.InitButton(wfData); //初始化 审批过程中的工作流按钮

          this.todolist = response.data.todolist;
          this.$refs.wfView.initData(response.data.todolist, formallowedit); //初始化 审批流程
          this.form.formallowedit = formallowedit;
          if (parseFloat(this.form.casestatus) >= 6) {
            //出纳办理
            this.isPayStep = true;
            this.activeNames = ["1", "2", "5", "6"];

            this.form.payuguid = this.userModel.uguid;
            this.form.payuname = this.userModel.uname;

          }
        });
      },
      saveData(workflowParam) {
        this.form.adddate = ""; //添加时间由后台绑定
        this.workflowParam = workflowParam;
        var error_msg = "";
        //出纳办理时，获取付款方式
        if (
          this.form.casestatus == "6" && workflowParam.wfhandletype != "draw" && workflowParam.wfhandletype != "back"
        ) {
          this.form.paydate = this.$refs.paymoney.actualpaydate;
          var paymethodData = this.$refs.paymoney.paymethodData;
          var paymethodTotalMoney = 0;
          //是否存在未选择的付款方式
          var existNoSelPayMethod = false;
          paymethodData.forEach((paymethod, index) => {
            // paymethodTotalMoney += parseFloat(paymethod.feemoney);
            if (!paymethod.categorycode) {
              existNoSelPayMethod = true;
            }
          });
          //存在未选择的付款方式
          if (existNoSelPayMethod) {
            error_msg = "请选择付款方式！";
          }
          this.form.paymethoddata = JSON.stringify(paymethodData);
          // var yinfumoney = parseFloat(this.form.paymoney) ;
          // if (paymethodTotalMoney.toFixed(2) != yinfumoney.toFixed(2)) {
          //   error_msg ="实际付款金额【" +paymethodTotalMoney +"】，与应付金额【" +yinfumoney +"】不一致！";
          // }
        }
        if (!this.tableDataFee.length) {
          error_msg = "尚未添加费用明细";
        } else if (this.existCorssYearTicket()) {
          //判断是否有跨年的票据
          error_msg = "存在不同年份的票据！";
        }

        //泰州三资，判断是否出纳提交
        //获取当前登录用户信息
        if (workflowParam.wfhandletype != "draw" &&
          workflowParam.wfhandletype != "back") {
          if (error_msg) {
            this.$message({
              message: error_msg,
              type: "error"
            });
            this.showButton();
            return;
          }
        }
        this.$refs.formPayInfo.validate(valid => {
          if (valid) {
            workflowParam.op = this.$refs.wfView.getOption();
            this.form.workflow = JSON.stringify(workflowParam);
            //添加时，生成摘要,规则：姓名(部门)报销 汽车票，火车票 （类别不超过4个）
            if (this.form.flag) {
              var summary = this.form.uname + "（" + this.form.applybydname + "）报销";
              var summaryTicket = "",
                summaryIndex = 0;
              this.tableDataFee.forEach((ticket, index) => {
                if (
                  summaryIndex < 4 &&
                  summaryTicket.indexOf(ticket.categoryname) == -1
                ) {
                  summaryTicket += ticket.categoryname + "、";
                  summaryIndex++;
                }
              });
              //拼接摘要，去除结尾的顿号
              this.form.summary =
                summary + summaryTicket.substr(0, summaryTicket.length - 1);
            }

            this.saveDataBaoXiao(workflowParam)
          } else {
            this.showButton();
          }
        });
      },
      saveDataBaoXiao(workflowParam) {
        //保存数据
        saveDataBaoXiao(this.form, this.form.flag).then(response => {
          if (response.data.code === 0) {
            this.$message({
              message: response.data.msg,
              type: "success"
            });
            if (workflowParam.wfhandletype == "draw") {
              //撤回操作，不关闭页面
              this.editPage(this.form.unitguid);
            } else {
              this.dialogFormVisible = false;
            }

            //刷新列表
            this.$emit("bindGrid");
          } else {
            this.$message({
              message: response.data.msg,
              type: "error"
            });
            this.showButton();
          }
        });
      },
      deleteData() {
        //删除方法
        deleteData({
          unitguid: this.form.unitguid
        }).then(response => {
          if (response.data.code === 0) {
            this.$message({
              message: "删除成功！",
              type: "success"
            });
            this.dialogFormVisible = false;
            //刷新列表
            this.$emit("bindGrid");
          } else {
            this.showButton();
            this.$message({
              message: response.data.msg,
              type: "error"
            });
          }
        });
      },
      initForm() {
        //初始化页面（新增、修改时都会调用）
        for (var key in this.form) {
          this.form[key] = "";
        }
        this.clearCustomerName();
        if (this.$refs.AutoCustomer1)
          this.$refs.AutoCustomer1.clearContent();
        //预先将审批流程 置空
        if (this.$refs.wfView !== undefined) this.$refs.wfView.initData("");
        (this.form.formallowedit = true),
          //下面开始给默认字段赋值
          (this.dialogFormVisible = true);
        this.form.flag = true;
        this.isPayStep = false;
      },
      //添加费用明细
      addFeeDetail() {
        //先选择费用明细
        this.$refs.SelectFeeType.addPage();
      },
      //选择费用类别后打开费用明细页面
      afterSelFeeType() {
        //选择费用类别后打开费用明细页面
        this.$refs.PaydetailEdit.addPage({
          feecode: this.$refs.SelectFeeType.selCategoryCode,
          feename: this.$refs.SelectFeeType.selCategoryName,
          needfapiao: this.$refs.SelectFeeType.needfapiao,
          MustFaPiao: this.$refs.SelectFeeType.MustFaPiao,
          tickettotaxpercent: this.$refs.SelectFeeType.tickettotaxpercent,
        });
      },
      //编辑费用
      editFeeDetail(index, row) {
        this.$refs.PaydetailEdit.editPage(row.unitguid);
      },
      //删除费用
      delFeeDetail(index, row) {
        this.$confirm("是否确定删除?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            deleteFeeDetail({
              unitguid: row.unitguid
            }).then(response => {
              if (response.data.code === 0) {
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
                this.bindFeeGrid(this.form.unitguid);
              } else {
                this.$message({
                  type: "error",
                  message: response.data.msg
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      },
      //获取费用合计行
      getFeeSummaries(param) {
        const {
          columns,
          data
        } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          } else if (
            column.property == "feemoney" ||
            column.property == "taxmoney" ||
            column.property == "submoney" ||
            column.property == "ticketsnums" ||
            column.property == "remark"
          ) {
            const values = data.map(item => Number(item[column.property]));
            if (!values.every(value => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0);

              if (column.property == "feemoney") {
                //获取支付总额
                this.form.paymoney = sums[index];
              } else if (column.property == "remark") {
                //显示合计金额
                sums[index] = convertToBigMoney(this.form.paymoney);
              }
              if (
                column.property != "ticketsnums" &&
                column.property != "remark"
              ) {
                sums[index] = ConvertMoney(parseFloat(sums[index]).toFixed(2), 2);

              }
            } else {
              sums[index] = "";
            }
          } else {
            sums[index] = "";
            return;
          }
        });

        return sums;
      },
      //绑定费用明细
      bindFeeGrid(unitguid) {
        if (unitguid) {
          //根据payguid获取费用明细
          getPayDetailByPayGuid({
              payguid: unitguid
            })
            .then(response => {
              if (response.data.obj) {
                this.tableDataFee = response.data.obj;
              }
            })
            .catch(error => {
              console.log(error);
            });
        } else {
          //根据uguid，和分类编码 获取未提交的费用明细
          getUnSubmitPayDetailList({
              uguid: this.form.uguid,
              formtype: this.form.formtype,
              categorycode: this.parentCategoryCode
            })
            .then(response => {
              if (response.data.obj) {
                this.tableDataFee = response.data.obj;
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      },
      showButton() {
        //恢复工作流按钮的 disabled 允许点击，一般在接口报错或者页面校验失败时调用
        this.$refs.wfHandle.showdisabledButton();
      },
      //判断是否存在跨年的票据
      existCorssYearTicket() {
        var ticketYears = [];
        this.tableDataFee.forEach((ticket, index) => {
          var yearFlag = new Date(ticket.feedate).getFullYear();
          if (ticketYears.indexOf(yearFlag) == -1) {
            ticketYears.push(yearFlag);
          }
        });
        return ticketYears.length > 1;
      },
      //打印
      print() {
        this.$nextTick(() => {
          this.$refs.PayPrint.show(this.form, this.tableDataFee, this.todolist);
        });
      },
      //打开选择收款人
      openSelectApply() {
        if (!this.form.formallowedit) {
          return;
        }
        this.$refs.applyTree.showTreeViewDialog();
      },
      //打开选择核算部门
      openSelectDept() {
        if (!this.form.formallowedit) {
          return;
        }
        this.$refs.deptTree.showTreeViewDialog();
      },
      //选择收款人后事件
      afterSelectApply(ids, texts, arr, rowindex) {
        if (arr.length > 0) {
          var selectednode = arr[0];
          this.form.applyby = selectednode.text
          this.form.applybyguid = selectednode.id
          // this.form.applybydname = selectednode.parentText || ""
          // this.form.applybydserial = selectednode.parentId || ""
        }

      },
      //选择部门后事件
      afterSelectDept(ids, texts, arr, rowindex) {
        if (arr.length > 0) {
          var selectednode = arr[0];
          this.form.applybydname = selectednode.text || ""
          this.form.applybydserial = selectednode.id || ""
        }

      },
    },
    mounted() {
      this.userModel=JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      this.isFinancial=this.$checkRight("财务");
    },
    components: {
      PayPrint, //付款打印
      PayMoney, //付款方式
      PaydetailEdit, //费用明细
      SelectFeeType, //选择费用
      CommTreeViewDialog, //通用部门人员选择组件
    }
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/oa/payform/ReimburseEdit.vue